import { Grid, Link } from "@mui/material";
import React from "react";

const Template = ({ label, onClick }) => {
  return (
    <Grid>
      <Link
        underline="none"
        onClick={onClick}
        sx={{
          fontSize: "16px",
          cursor: "pointer",
          fontWeight: 700,
          color: "#33499F",
          marginTop: "10px",
          "&:hover": { color: "#1565c0" },
        }}
      >
        {label}
      </Link>
    </Grid>
  );
};

export default Template;
